import { html, type TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';
import { SuperElement } from '../../internals/super/SuperElement';
import { iconStyles } from './Icon.styles';

export type LrIconSize = 'small' | 'medium' | 'big' | 'large';

export abstract class IconBase extends SuperElement {
    @property({ type: String, reflect: true }) size: LrIconSize = 'medium';
    @property({ type: String }) viewBox = '0 0 32 32';

    static styles = [SuperElement.styles, iconStyles];
}

export function createIconComponent(name: string, pathData: TemplateResult) {
    class IconComponent extends IconBase {
        renderElement() {
            return html`<svg viewBox="${this.viewBox}" aria-hidden="true" fill="none" part="icon">${pathData}</svg> `;
        }
    }

    customElements.define(name, IconComponent);
}
